import {Injectable} from "@angular/core";

@Injectable()
export class AppSettingsProvider {
	public draftMode;

	constructor() {

	}
}
